import { useState, createContext, useEffect} from 'react';
import { auth, db } from '../services/firebaseConnection';
import { getAuth,fetchSignInMethodsForEmail, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';


import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';


export const AuthContext = createContext({});

function AuthProvider({children}){
    const [user, setUser] = useState(null)
    const [loadingAuth, setLoadingAuth] = useState(false);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        async function loadUser(){
            const storageUser = localStorage.getItem('@ticketsTreck')

            if(storageUser){
                setUser(JSON.parse(storageUser))
                setLoading(false);
            }

            setLoading(false);
    }
    
    loadUser();
}, [])

    async function signIn(email, password){
        setLoadingAuth(true);

        await signInWithEmailAndPassword(auth, email, password)
        .then(async(value) => {
            let uid = value.user.uid;

            const docRef = doc(db, "users",uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let data = {
                    user_id: uid,
                    nome: docSnap.data().nome, 
                    username: docSnap.data().username,
                    email: value.user.email,
                    avatarUrl: docSnap.data().avatarUrl
                }
    
                setUser(data);
                storageUser(data);
                setLoadingAuth(false);
                toast.success("Bem-vindo(a) de volta!")
                navigate("/feed")
                
            } else {
                toast.error("Usuário não encontrado");
                setLoadingAuth(false);
            }
        })
        .catch((error) => {
            console.log(error);
            setLoadingAuth(false);
            toast.error("Ops algo deu errado!");
        })
    }

    

    async function signUp(email,password,username, name){
        setLoadingAuth(true);

        await createUserWithEmailAndPassword(auth, email, password)
        .then(async(value) => {
            let uid = value.user.uid

            await setDoc(doc(db, "users", uid),{
                nome: name,
                username: username,
                avatarUrl: null
            })
            .then(() =>{
                let data = {
                    user_id: uid,
                    nome: name,
                    username: username,
                    email: value.user.email,
                    avatarUrl: null
                }
                setUser(data);

                storageUser(data);

                setLoadingAuth(false);

                toast.success("Seja bem-vindo(a) ao sistema!")
                navigate("/feed")
            })
        })
        .catch((error) => {
            alert(error);
            setLoadingAuth(false);
        })
    }

    function storageUser(data){
        localStorage.setItem('@ticketsTreck', JSON.stringify(data))
    }

    async function logout(){
        await signOut(auth);
        localStorage.removeItem('@ticketsTreck');
        setUser(null);
    }
    

    async function EmailExist(email) {
        const auth = getAuth();
    try {
        const cleanEmail = email.trim().toLowerCase(); 
        const signInMethods = await fetchSignInMethodsForEmail(auth, cleanEmail);
        return signInMethods.length > 0; 
    } catch (error) {
        return false;
    }
    }

    async function getGame(userId) {
        const gameDocRef = doc(db, "game", userId); 
        const gameDoc = await getDoc(gameDocRef);
      
        if (gameDoc.exists()) {
          return gameDoc.data(); 
        } else {
          console.error("Não há game!");
          return null;
        }
      }

      async function atualizarXP(userId, novoXP, nivel) {
        try {
            const gameDocRef = doc(db, "game", userId);
            await setDoc(gameDocRef, { 
                xp: novoXP, 
                nivel: nivel,
                userId: userId
            }, { merge: true });
        } catch (error) {
            console.error("Erro ao atualizar XP e nível:", error);
        }
    }

    return(
        <AuthContext.Provider
        value={{
            signed: !!user,
            user,
            signIn,
            signUp,
            logout,
            loadingAuth,
            loading,
            storageUser, 
            setUser,
            EmailExist,
            getGame,
            atualizarXP
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;